// VesselsPageWrapper.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import VesselsPage from './VesselsPage';

export default function VesselsPageContainer(props) {
  const params = useParams();
  const navigate = useNavigate();

  return (
    <VesselsPage
      {...props}
      match={{ params }} // simulate React Router v5's match
      history={{ push: navigate }}
    />
  );
}
